import {
	SET_ORDER_GROUP_INFO,
	GET_ORDER_GROUP_INFO,
	SET_ORDER_GROUP_INFO_LOADING,
	SET_IS_ORDER_GROUP_DELETING,
	SET_IS_ORDER_GROUP_SAVING,
	SET_TYPES,
	SET_IS_TYPES_LOADING,
	SET_MODES,
	SET_IS_MODES_LOADING,
	SET_PERIODS,
	SET_IS_PERIODS_LOADING,
	SET_ADDRESSES_OPTIONS,
	SET_IS_ADDRESSES_LOADING,
	SET_ADDRESSES_SEARCH_VALUE,
	RESET_STATE,
	SET_IS_TRANSPORT_TYPES_LOADING,
	SET_TRANSPORT_TYPES,
	SET_IS_CONFIGS_LOADING,
	SET_CONFIGS,
	SET_AUTOPARKS,
	SET_IS_AUTOPARKS_LOADING,
	SET_TARIFF_TYPES,
	SET_IS_TARIFF_TYPES_LOADING,
} from './actions';

export const initialState = {
	orderGroupInfo: null,
	isOrderGroupInfoLoading: false,
	isOrderGroupDeleting: false,
	addressesOptions: {},
	addressesSearchValue: {},
	isAddressesLoading: {},
	periodsOptions: [],
	isPeriodsLoading: false,
	isOrderGroupSaving: false,
	types: null,
	isTypesLoading: false,
	configs: null,
	isConfigsLoading: false,
	transportTypes: null,
	isTransportTypesLoading: false,
	modes: null,
	isModesLoading: false,
	autoparks: null,
	isAutoparksLoading: false,
	tariffTypes: null,
	isTariffTypesLoading: false,
};

const orderGroupsModalReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case GET_ORDER_GROUP_INFO:
			return { ...state };
		case SET_ORDER_GROUP_INFO:
			return { ...state, orderGroupInfo: payload };
		case SET_ORDER_GROUP_INFO_LOADING:
			return { ...state, isOrderGroupInfoLoading: payload };
		case SET_IS_ORDER_GROUP_DELETING:
			return { ...state, isOrderGroupDeleting: payload };
		case SET_IS_ORDER_GROUP_SAVING:
			return {
				...state,
				isOrderGroupSaving: payload,
			};
		case SET_TYPES:
			return {
				...state,
				types: payload,
			};
		case SET_IS_TYPES_LOADING:
			return {
				...state,
				isTypesLoading: payload,
			};
		case SET_CONFIGS:
			return {
				...state,
				configs: payload,
			};
		case SET_IS_CONFIGS_LOADING:
			return {
				...state,
				isConfigsLoading: payload,
			};
		case SET_TRANSPORT_TYPES:
			return {
				...state,
				transportTypes: payload,
			};
		case SET_IS_TRANSPORT_TYPES_LOADING:
			return {
				...state,
				isTransportTypesLoading: payload,
			};
		case SET_MODES:
			return {
				...state,
				modes: payload,
			};
		case SET_IS_MODES_LOADING:
			return {
				...state,
				isModesLoading: payload,
			};
		case SET_PERIODS:
			return {
				...state,
				periodsOptions: payload,
			};
		case SET_IS_PERIODS_LOADING:
			return {
				...state,
				isPeriodsLoading: payload,
			};
		case SET_ADDRESSES_OPTIONS:
			return {
				...state,
				addressesOptions: payload,
			};
		case SET_IS_ADDRESSES_LOADING:
			return {
				...state,
				isAddressesLoading: payload,
			};
		case SET_ADDRESSES_SEARCH_VALUE:
			return {
				...state,
				addressesSearchValue: payload,
			};
		case SET_AUTOPARKS:
			return {
				...state,
				autoparks: payload,
			};
		case SET_IS_AUTOPARKS_LOADING:
			return {
				...state,
				isAutoparksLoading: payload,
			};
		case SET_TARIFF_TYPES:
			return {
				...state,
				tariffTypes: payload,
			};
		case SET_IS_TARIFF_TYPES_LOADING:
			return {
				...state,
				isTariffTypesLoading: payload,
			};
		case RESET_STATE:
			return {
				...state,
				addressesOptions: {},
				addressesSearchValue: {},
				isAddressesLoading: {},
				orderGroupInfo: null,
				isOrderGroupInfoLoading: false,
				isOrderGroupDeleting: false,
				isOrderGroupSaving: false,
				types: null,
				isTypesLoading: false,
				modes: null,
				autoparks: null,
				isAutoparksLoading: false,
				tariffTypes: null,
				isTariffTypesLoading: false,
			};
		default:
			return state;
	}
};

export default orderGroupsModalReducer;
